// OpenDefaultOutFileHeadless.jsx
import { useEffect } from "react"
import { SwmmOut } from "@fileops/swmm-node"
import "../../css/index.css"

/**
 * 
 * @param {function} setModel sets the swmm model in JSON format
 * @param {string} fileName the path and name of an epa-swmm file
 * @param {function} setSwmmTxt sets the swmm model .inp file contents in string format
 * @param {function} setSwmmOut sets the swmm .out file contents
 * @param {function} setRpt sets the .rpt file contents in string format
 * @param {function} setLoadModel sets loadModel flag, signals to other components that a new model has been loaded and old results invalidated.
 * @param {function} closeAll closes all dialogs that relate input and output for the model and interface.
 * @returns null. This is rebuilt from a headed component and should recieve more refactoring.
 */
const OpenDefaultOutFileHeadless = ({setModel, fileName, setSwmmTxt, setSwmmOut, setRpt, setLoadModel, closeAll}) => {
  async function showFile () {
    // Read the input file
    fetch(fileName)
      .then((r)=>r.arrayBuffer())
      .then(blob =>{
        //let jsonSWMM = SwmmConvert.parseInput(text)
        //setSwmmTxt(text)
        //setModel(jsonSWMM)
        //setLoadModel(prev=>prev+1)
        let swmmOut = new SwmmOut(blob)
        setSwmmOut(swmmOut)
      })
  }

  useEffect(()=>{
    closeAll()
    if(fileName !== ''){
      showFile()
    }
  }, [fileName])

  return(null)
}
 
export {OpenDefaultOutFileHeadless}